import { createApiCall } from "services/api/createApiCall";
import { SalesChannel } from "./types";

export const getSalesChannelsAPI = async (): Promise<SalesChannel[]> => {
  const response = await createApiCall(
    { path: "/v1/sales/channels", method: "GET" },
    { getMessage: { error: (error: any) => `${error.response.data.message}` } }
  )();
  return response.data;
};
